module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtBAMAAADINP+pAAAAFVBMVEUAAAD///////////////////////9Iz20EAAAABnRSTlMAABll4Pjgs5+NAAAAOElEQVQ4y2NgGAZAEATE0tLSwAyBYS+uGgoEYUBxEB2qABc3S0MGBgMuPtLiBcwVCQ0NQRMfhgAAM1VQN2hTPwAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_icon_toolbar_request_white.png
// module id = 839
// module chunks = 0